/*
 * Deprecating this functionality and no new functionality should be added to this file.
 * Can't delete this yet. This is being by some campaigns.
 * Template:/templates/campaigns/section-sidebar.php
*/

var skSticky = {
  pageScroll: function(pageSticky) {
    var stickyParams = {
      container       : pageSticky,
      containerHeight : pageSticky.children('ul').height(),
      footer          : jQuery('#footer'),
      windowSize      : jQuery(window).width()
    };

    if (stickyParams.windowSize > 768) {

      var pageTop           = jQuery(window).scrollTop();
      var containerOffset   = stickyParams.container.offset().top;
      var footerOffset      = stickyParams.footer.position().top;
      var distance          = (containerOffset - pageTop);
      var footerDistance    = (footerOffset - pageTop);
      var containerChildren = stickyParams.container.children();


      if (distance < 100) {
        containerChildren.toggleClass('stick', stickyParams.containerHeight < footerDistance);
      } else {
        containerChildren.removeClass('stick');
      }
    }
  },
  pageScrollMobile: function(pageSticky) {
    var stickyParams = {
      container       : pageSticky,
      containerHeight : pageSticky.children('ul').height(),
      footer          : jQuery('#footer'),
      windowSize      : jQuery(window).width()
    };

    var pageTop         = jQuery(window).scrollTop();
    var containerOffset = stickyParams.container.offset().top;
    var footerOffset    = stickyParams.footer.position().top;
    var distance        = (containerOffset - pageTop);
    var footerDistance  = (footerOffset - pageTop);

    if (distance < 100) {
      stickyParams.container.children().addClass('stick');
      if (stickyParams.containerHeight > footerDistance) {
        stickyParams.container.children().removeClass('stick');
      }
    } else if (distance > 99) {
      stickyParams.container.children().removeClass('stick');
    }
  },
  pageHideMobile: function(pageSticky) {
    var stickyParams = {
      container : pageSticky
    };
    stickyParams.container.toggle();
  },
  pageResize: function(pageSticky) {
    pageSticky.children().removeClass('stick');
  }
}

module.exports = skSticky;
